import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { resetStatus } from "../redux/organizationsSagas";
import { MainModal } from "../../../../components/modal/MainModal";
import { ErrorList } from "./ErrorList";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { showToast } from "../../../../utils/showToast";
import { useError } from "../../../../hooks/useError";
import { useOrganizationEdit } from "../hooks/useOrganizationEdit";
import { TABS } from "../constants";

export const Edit = ({ isOpen, onClose, selected: { id, businessName: name } }) => {
  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState("General");

  const {
    register,
    control,
    formState: { errors, isSubmitting, isLoading },
    watchedValues,
    submit,
    currentOrganizationInfo,
    setCurrentOrganizationInfo
  } = useOrganizationEdit({ id });

  const [showFutureAppointments, membershipMetric] = watchedValues;

  const close = () => {
    dispatch(resetStatus());
    onClose();
    setCurrentOrganizationInfo({});
  };

  const { errors: serverErrors, status } = useError({
    cb: () => {
      showToast("Organization was successfully edited");
      close();
    },
    sliceKey: "organizations"
  });

  const primaryButtonDisabled = isSubmitting || status == "pending";

  const renderActiveTab = () => {
    let Component = TABS[activeTab];

    let retentionProps = activeTab === "Retention" ? { showFutureAppointments } : {};
    let dashboardProps =
      activeTab === "Dashboard"
        ? {
            isEditMode: true,
            defaultRevenueCategoriesOnTotalRevenueModule:
              currentOrganizationInfo.defaultRevenueCategoriesOnTotalRevenueModule
          }
        : {};

    let clubreadyProps =
      activeTab === "ClubReady"
        ? {
            membershipMetric,
            isEditMode: true,
            agreementNamesWithZeroSales: currentOrganizationInfo.agreementNamesWithZeroSales
          }
        : {};

    return (
      <Component
        register={register}
        control={control}
        {...retentionProps}
        {...clubreadyProps}
        {...dashboardProps}
      />
    );
  };

  return (
    <>
      <MainModal
        isLoading={isLoading}
        isOpen={isOpen}
        onClose={close}
        parentSelector=".admin-organizations"
        headerText={`Edit Organization ${name}`}
        headerCloseHandler={close}
        bodyClassName="main-popup-body"
        primaryButtonText="Save"
        primaryButtonClass="primary"
        primaryButtonDisabled={primaryButtonDisabled}
        primaryBtnHandler={submit}
        containerClassName="add"
        secondaryBtnText="Cancel"
        secondaryBtnClass="secondary"
        secondaryBtnHandler={close}
        height={645}
        width={900}
        isAdminPanel={false}
      >
        <div className="tabs">
          <div className="tabs__list">
            {Object.entries(TABS).map(([tabName]) => (
              <button
                key={tabName}
                className={`tabs__tab ${activeTab === tabName ? "tabs__tab--active" : ""}`}
                onClick={() => setActiveTab(tabName)}
              >
                {tabName}
              </button>
            ))}
          </div>

          <div id="hook-form">{renderActiveTab()}</div>
        </div>

        {status === "pending" && <LoadingAnimation uiLoader />}
        <ErrorList errors={{ ...errors, ...serverErrors }} />
      </MainModal>
    </>
  );
};
